import { SPORTSBOOKS } from "../../../lib/constants";

function SportsbookSelector({ sportsbook, onChange, labelStyle }) {
  return (
    <>
      <div style={{...labelStyle,marginBottom:8}}>Sportsbook</div>
      <div style={{display:"flex",gap:8}}>
        {/* Only supported books: greyed "Coming Soon" chips read as unfinished features in App Review (2.1). */}
        {SPORTSBOOKS.filter(s=>s.active).map(s=>(
          <button key={s.id} onClick={()=>onChange(s.id)}
            style={{flex:1,padding:"9px 4px",borderRadius:10,border:`1px solid ${sportsbook===s.id?s.color+"66":"#1e293b"}`,background:sportsbook===s.id?s.bg:"#060e1b",cursor:"pointer",fontFamily:"inherit"}}>
            <div style={{fontSize:11,fontWeight:800,color:sportsbook===s.id?s.color:"#334155"}}>{s.name}</div>
          </button>
        ))}
      </div>
    </>
  );
}

export default SportsbookSelector;
